module.exports = __webpack_public_path__ + "img/callIm2.331f2975.png";